import React from "react";
import "./Button.scss";

const Button = ({
  className,
  children,
  icon: Icon,
  onClick,
  active,
  disabled,
  href, // 👈 new prop
  target, // 👈 new prop (e.g. _blank)
  ...rest
}) => {
  const isLink = Boolean(href);

  const commonProps = {
    className: `button ${className} ${active ? "active" : ""} ${
      disabled ? "disable" : ""
    }`,
    onClick: !disabled && !isLink ? onClick : undefined,
    ...rest,
  };

  // If there's an href, render an anchor tag instead of div
  if (isLink) {
    return (
      <a
        {...commonProps}
        href={!disabled ? href : undefined}
        target={target || "_self"}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
      >
        {Icon && <Icon className="button-icon" />}
        {children}
      </a>
    );
  }

  // Default (non-link) button
  return (
    <div {...commonProps}>
      {Icon && <Icon className="button-icon" />}
      {children}
    </div>
  );
};

Button.defaultProps = {
  className: "",
  icon: null,
  onClick: () => {},
  active: false,
  disabled: false,
  href: null,
  target: "_self",
};

export default Button;
